export default function Services() {
  return (
    <div className="fade-in">
      <h2>Services Offered</h2>

      <div className="grid-container">
        <div className="grid-card">
          <h3>Technical Consultation</h3>
          <p>
            Expert guidance for RF, Microwave, and communication system designs.
          </p>
        </div>

        <div className="grid-card">
          <h3>Global Sourcing</h3>
          <p>
            Reliable sourcing of high-quality components from global OEMs.
          </p>
        </div>

        <div className="grid-card">
          <h3>Testing & Validation</h3>
          <p>
            In-house and partner lab testing for compliance and performance.
          </p>
        </div>

        <div className="grid-card">
          <h3>After-Sales Support</h3>
          <p>
            Dedicated technical and commercial support throughout the product
            lifecycle.
          </p>
        </div>
      </div>
    </div>
  );
}
